import { TenantService } from './tenant.service';

export function tenantInitializerFactory(tenantService: TenantService) {
  return () => tenantService.init();
}